import React from 'react';
import PropTypes from 'prop-types';
import Menu from 'components/MainMenu/Menu';
import * as navItems from 'dictionaries/Navigation';

const menuTypes = {
  1: navItems.staffNav,
  2: navItems.vendorNav,
  3: navItems.labNav,
  4: navItems.accountantNav
};

const MenuRenderer = ({ userRole, show }) => {
  const items = menuTypes[userRole];

  if (items) {
    return <Menu show={show} items={items} />;
  }

  return () => null;
};

MenuRenderer.propTypes = {
  userRole: PropTypes.number.isRequired,
  render: PropTypes.bool
};

export default MenuRenderer;



// WEBPACK FOOTER //
// ./src/components/MainMenu/MenuRenderer.js